import { useRef, useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import hintArrow from '../../images/hint-arrow.svg'
import hintArrowYellow from '../../images/hint-arrow-yellow.svg'

const YearIndicator = ({
  tenant,
  colorMode,
  isMobile,
  currentIndex,
  setIndex,
  hasSelected,
  setHasSelected,
  slideContent,
}: {
  tenant?: Tenant // or simply Object
  colorMode?: String
  isMobile?: Boolean
  currentIndex: number
  setIndex?: any
  hasSelected?: any
  setHasSelected?: any
  slideContent?: any
}) => {
  const [knowsYears, setKnowsYears] = useState(false)
  const [wrapperWidth, setWrapperWidth] = useState(0)
  const wrapperRef = useRef<any>()

  const handleClick = (index: number) => {
    // console.log('clicked', index)
    setIndex(index)
    setHasSelected(true)
    setKnowsYears(true)
    const setKnowsyears = new CustomEvent('userKnowsYears', {
      detail: true,
    })
    window.dispatchEvent(setKnowsyears)
  }

  useEffect(() => {
    //place hint arrow
    setWrapperWidth(wrapperRef.current ? wrapperRef.current.offsetWidth : 0)
    // console.log('wrapper width:', wrapperRef.current.offsetWidth)

    window.addEventListener('userKnowsYears', onKnowsYears)
    return () => {
      window.removeEventListener('userKnowsYears', onKnowsYears)
    }
  }, [currentIndex]) // listen to index change

  // the function that is called when the event 'knowsYears' is fired
  const onKnowsYears: any = useCallback((event: CustomEvent) => {
    setKnowsYears(event.detail)
  }, [])

  return (
    <Indicator>
      {!knowsYears && (
        <Hint
          style={{
            marginLeft: wrapperWidth / 2 + 26 + 'px',
          }}
        >
          <div>Jahre steuern</div>
          <img
            src={colorMode === 'dark' ? hintArrowYellow : hintArrow}
            alt='hint'
          />
        </Hint>
      )}
      <div ref={wrapperRef} className='btn-wrapper'>
        {slideContent.map((element: any, index: number) => {
          return (
            <>
              <div
                className={currentIndex === index ? 'btn active' : 'btn'}
                key={'btn-' + index}
                onClick={() => handleClick(index)}
              >
                {slideContent[index].year}
              </div>
            </>
          )
        })}
      </div>
    </Indicator>
  )
}
const Indicator = styled.div`
  margin: auto;
  @media (max-width: 600px) {
    margin: 0.3rem auto 0.7rem;
  }
  padding: 0;
  position: relative;
  .btn {
    display: inline-block;
    padding: 0.25rem 0.75rem;
    font-size: 1.5rem;
    line-height: 2.4rem;
    max-width: 8rem;
    background-color: var(--year-indicator-inactive);
    color: var(--text-color);
    border-radius: 0.2em;
    margin: 0.4rem 0.25rem 3rem;
    cursor: pointer;
    border: 1px solid var(--year-indicator-border);
  }

  /* Active btn */
  .btn.active,
  .btn:hover {
    background-color: var(--year-indicator);
    color: white;
    border-color: var(--year-indicator-border);
  }

  .btn-wrapper {
    width: fit-content;
    margin: 0 auto;
  }
`

const Hint = styled.div`
  position: absolute;
  width: 100%;
  max-width: 100%;
  left: 0;
  margin-top: -58px;
  margin-left: 100vw; // is set via JS
  div {
    line-height: 2rem;
    font-size: 1.3rem;
  }

  text-shadow: 0 0 3px var(--section-background),
    0 0 3px var(--section-background), 0 0 3px var(--section-background),
    0 0 3px var(--section-background), 0 0 3px var(--section-background);
`

export default YearIndicator
